import ScrollReveal from "@/components/base/ScrollReveal";

export default function CtaSection() {
  return (
    <section className="bg-brand-black relative overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-[480px] md:min-h-[560px]">
        {/* Left: Title area */}
        <ScrollReveal className="lg:w-1/2 relative flex items-end p-8 md:p-12 lg:p-16" direction="left">
          {/* Left gold glow */}
          <div
            className="absolute left-0 bottom-0 w-[350px] h-[350px] md:w-[450px] md:h-[450px] rounded-full opacity-10"
            style={{
              background: "radial-gradient(circle, #D4AF37 0%, transparent 70%)",
            }}
          />

          <div className="relative z-10">
            <h2 className="text-white font-display font-bold text-[2rem] md:text-[2.75rem] leading-[1.3] mb-6">
              你的保障與財務規劃，需要一位門神把關。
            </h2>
          </div>
        </ScrollReveal>

        {/* Right: Action area */}
        <ScrollReveal className="lg:w-1/2 bg-brand-card flex items-center justify-center p-8 md:p-12 lg:p-16" direction="right" delay={150}>
          <div className="text-center max-w-[440px]">
            <p className="text-brand-text-secondary text-[1.1875rem] leading-[1.75] mb-8">
              30–45 分鐘初談健診，先釐清現況，再找出最適合你的下一步。
            </p>
            <a
              href="https://lin.ee/o51JBHX"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-brand-gold text-brand-black px-10 py-4 rounded-full text-[1.125rem] font-semibold hover:bg-brand-gold-soft transition-colors whitespace-nowrap w-full sm:w-auto"
            >
              <i className="ri-line-fill" />
              加入 LINE 諮詢
            </a>
            <p className="text-brand-gold text-[0.9375rem] mt-4">
              通常 24 小時內回覆
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}